var render, staticRenderFns
import script from "./CrtListCompanies.vue?vue&type=script&lang=js&"
export * from "./CrtListCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b0e473b')) {
      api.createRecord('7b0e473b', component.options)
    } else {
      api.reload('7b0e473b', component.options)
    }
    
  }
}
component.options.__file = "src/views/Report/Company/CrtListCompanies.vue"
export default component.exports